import UploaderRecommendations from './UploaderRecommendations';

export default UploaderRecommendations;
